export default __webpack_public_path__ + "static/media/sf4.6fd286f0.svg";